import { useEffect, useState, type ChangeEvent } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import Button from '../../../juristec-ui/core/Button';
import IconButton from '../../../juristec-ui/core/IconButton';
import InputTextLine from '../../../juristec-ui/core/InputTextLine';

import { compactString } from '../../../juristec-ui/utils/functions/formatString';
import { verifyInput, verifyEmail } from '../../../juristec-ui/utils/validators/inputTextValidators';
import { FirebaseLoginProps } from '../types';

import {
  Visibility,
  VisibilityOff,
} from '../../../juristec-ui/icons';

import {
  FormFieldSet,
  FormField,
  TextOptions,
  HiddenInput,
} from '../styled';

const FirebaseLogin = ({
  emailState, passwordState, passwordLogin, t, goBack,
}: FirebaseLoginProps) => {
  const [email, setEmail] = emailState;
  const [password, setPassword] = passwordState;
  const [showPass, setShowPass] = useState<boolean>(false);

  useEffect(() => {
    if (!email) goBack();
  }, []);

  const passwordHandle = (val: string) => {
    const msg = verifyInput(val, true, 6);
    setPassword({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  const passwordEvent = (e: ChangeEvent<HTMLInputElement>) => {
    passwordHandle(compactString(e.target.value));
  };

  const emailHandle = (val: string) => {
    const msg = verifyEmail(val, true);
    setEmail({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  const emailEvent = (e: ChangeEvent<HTMLInputElement>) => {
    emailHandle(compactString(e.target.value));
  };

  const handleLogin = () => {
    if (password.error) passwordHandle(password.value);
    else passwordLogin();
  };

  return (
    <FormFieldSet>
      <h2>{t('loginTitle')}</h2>
      <HiddenInput
        type="email"
        name="email"
        autoComplete="username"
        value={email.value}
        onChange={emailEvent}
      />
      <FormField style={{ position: 'relative' }}>
        <InputTextLine
          name="password"
          label={t('passwordLabel')}
          type={!showPass ? 'password' : 'text'}
          value={password.value}
          errorMessage={password.errorMsg}
          error={password.errorMsg.length > 0}
          notTransparent={false}
          onChange={passwordEvent}
          style={{ paddingRight: '35px' }}
          setValue={() => {}}
          autoComplete="off"
          autoFocus
        />
        <IconButton
          style={{
            position: 'absolute',
            bottom: 4,
            right: 2,
            boxShadow: 'none',
            padding: 2,
          }}
          type="button"
          variant="pattern"
          iconColor="black"
          onMouseDown={() => setShowPass(!showPass)}
        >
          {showPass ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </FormField>
      <FormField>
        <Button
          type="submit"
          onClick={handleLogin}
          textTransform="none"
          color="primary"
          size="large"
          style={{ width: '100%', margin: '20px 0 10px 0' }}
        >
          {t('enterPasswordBtn')}
        </Button>
      </FormField>
      <TextOptions style={{ marginLeft: 'auto' }}>
        <Trans
          t={t}
          i18nKey="changePasswordOption"
          components={{
            change: <Link to="/login/reset_password" />,
          }}
        />
      </TextOptions>
    </FormFieldSet>
  );
};

export default FirebaseLogin;
